import { createSlice } from '@reduxjs/toolkit'
import { PayloadAction } from '@reduxjs/toolkit'

import { StudioCampaign } from 'models/StudioCampaign'

// Define the initial state for the slice
// Build an empty state form the StudioCampaign model
const initialState: StudioCampaign = {
  _id: '',
  campaign_data: {
    internal_name: '',
    redirect_url: null,
    timezone_identifier: '',
    contact_phone: '',
    location_details: '',
    raw_currency_code: '',
    raw_goal: 0,
    campaign_template_id: null,
    classy_live_event_id: null,
    name: '',
    started_at: '',
    ended_at: null,
    venue: null,
    created_at: '',
    updated_at: '',
    postal_code: null,
    address1: null,
    city: null,
    state: null,
    country: '',
    goal: 0,
    external_url: '',
    contact_email: '',
    designation_id: 0,
    type: '',
    organization_id: 0,
    canonical_url: '',
    currency_code: '',
    effective_fixed_fot_percent: '',
    effective_flex_rate_percent: 0,
    effective_recaptcha_settings: 'ENABLED',
    crypto_giving: '',
    embedded_giving: '',
    exit_modal: false,
    fixed_fot_percent: null,
    flex_rate_percent: 0,
    is_billing_address_required: false,
    is_ended_at_hidden: false,
    is_started_at_hidden: false,
    use_intelligent_ask_onetime: false,
    use_intelligent_ask_recurring: false,
    whitelist_url: null,
    allow_ecards: false,
    classy_mode_appeal: '',
    classy_mode_checked_by_default: false,
    classy_mode_enabled: false,
    corporate_donation_enabled: false,
    dcf_allowed: false,
    dcf_enabled: false,
    disable_donation_attribution: false,
    hide_anonymous_donations: false,
    hide_contact_opt_in: false,
    hide_donation_amounts: false,
    hide_dedications: false,
    hide_donation_comments: false,
    hide_recurring_end_date: false,
    minimum_donation_amount: 0,
    offer_dedication_postal_notifications: false,
    opt_in_checked_by_default: false,
    return_url: null,
    send_dedication_emails: false,
    resource_urn: '',
  },
  campaign_id: 0,
  campaign_status: '',
  checkout: {
    cart: {
      is_enabled: false,
    },
    revenue_location_code: {
      enabled: false,
    },
  },
  created_at: '',
  modules: {
    designation_group: [],
    sharing: {
      id: 0,
      email_body: '',
      email_subject: '',
      facebook_asset_id: null,
      facebook_image_url: null,
      facebook_video_url: null,
      facebook_text: '',
      instagram_asset_id: null,
      instagram_image_url: null,
      instagram_text: null,
      linkedin_text: null,
      sms_text: '',
      twitter_text: '',
    },
    question: [],
    analytics_service_settings: [],
    ecard: [],
  },
  organization_id: 0,
  owner_id: 0,
  published_at: '',
  schema_version: 0,
  status: '',
  updated_at: '',
  version: 0,
}

export const campaignSlice = createSlice({
  name: 'campaign',
  initialState,
  reducers: {
    setCampaign: (state, action: PayloadAction<StudioCampaign>) => {
      return action.payload
    },
  },
})

export const { setCampaign } = campaignSlice.actions

// Export the reducer
export default campaignSlice.reducer
